export default function normalizeLocale(lang) {
  const locale = String(lang || 'uk').toLowerCase();
  return locale === 'ru' ? 'uk' : locale;
}
